import React, { memo, forwardRef } from "react";
const SvgPermutationswithrepetitions = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M13.52 15.02h1.76a8.35 8.35 0 001.18-.08 3.668 3.668 0 001-.32c.293-.16.527-.373.7-.64.173-.267.26-.613.26-1.04 0-.413-.087-.747-.26-1a1.752 1.752 0 00-.7-.62 2.72 2.72 0 00-.98-.28 7.64 7.64 0 00-1.12-.08h-1.84v4.06zm2.1-6.18c.813 0 1.547.073 2.2.22.653.147 1.213.387 1.68.72.467.333.827.76 1.08 1.28.253.52.38 1.147.38 1.88 0 .787-.147 1.447-.44 1.98a3.622 3.622 0 01-1.2 1.3c-.493.32-1.073.553-1.74.7a9.846 9.846 0 01-2.12.22h-1.94v4.62c0 .307-.047.553-.14.74a1.345 1.345 0 01-.34.42.814.814 0 01-.4.2c-.147.04-.273.06-.38.06-.107 0-.233-.02-.38-.06a.938.938 0 01-.42-.2 1.516 1.516 0 01-.32-.42c-.093-.187-.14-.433-.14-.74V10.34c0-1 .5-1.5 1.5-1.5h3.12z"
      />
      <rect width={6} height={8} x={23} y={19} fill="#DBDBDB" rx={1} />
      <rect width={6} height={8} x={3} y={19} fill="#DBDBDB" rx={1} />
      <path
        fill="#717171"
        d="M5.054 6.552h.862c.15 0 .302-.01.452-.033.15-.022.285-.064.402-.126a.797.797 0 00.301-.26.783.783 0 00.117-.443.656.656 0 00-.108-.393.794.794 0 00-.277-.251 1.158 1.158 0 00-.385-.126 2.594 2.594 0 00-.41-.033h-.954v1.665zm.77.862h-.77v1.992c0 .128-.02.231-.058.31a.563.563 0 01-.142.175.34.34 0 01-.168.084.618.618 0 01-.159.025.618.618 0 01-.159-.025.393.393 0 01-.176-.084.634.634 0 01-.133-.176.696.696 0 01-.059-.31V4.629C4 4.209 4.21 4 4.628 4h1.43c.28 0 .55.03.812.092.263.056.494.15.695.285.206.133.37.31.494.527.122.217.184.482.184.795 0 .43-.123.78-.369 1.054-.24.268-.569.45-.987.544L8.134 9.13a.668.668 0 01.092.192.494.494 0 01-.117.536.498.498 0 01-.368.142.557.557 0 01-.235-.059.62.62 0 01-.226-.226l-1.456-2.3z"
      />
    </svg>
  );
});
SvgPermutationswithrepetitions.displayName = "SvgPermutationswithrepetitions";
const MemoForwardRef = memo(SvgPermutationswithrepetitions);
export default MemoForwardRef;
